<!-- eslint-disable no-redeclare -->
<template>
    <div id="page" class="container">
        <div class="overFixed">
            <div id="map" class="map" style="height: 72vh;width: 100%;margin:0 auto;"></div>
            <div id="section">
                <div class="equipment">
                    设备编号：{{user.imei}}
                    <div class="boxRadius green" v-if="user.imeiState == 0">
                        在线
                    </div>
                    <div class="boxRadius error" v-else>
                        离线
                    </div>
                </div>
                <div class="user_section" style="position: relative;">
                    <div class="avatarName">
                        <img id="headimgurl" :class="showHide == 1 ? '' : 'headimgurl'" v-if="user.avatar" style="width: 100px;height: 110px;" :src="user.avatar" alt="">
                        <img id="headimgurl" :class="showHide == 1 ? '' : 'headimgurl'" v-else src="../../img/photo.png" alt="">
                        <div id="user_card">
                            <img :src="user.typeimg" alt="">
                            <span>{{ user.typeshow }}</span>
                        </div>
                    </div>

                    <dl style="width: 70%;">
                        <dt><img src="../../img/icon1.png" alt=""> 使用者信息</dt>
                        <dd>
                            <span>姓      名：{{showHide == 1 ? user.name : user.names}}</span>      电话：{{showHide == 1 ? user.tel : user.tels}}
                        </dd>
                        <dd>过往病史：{{user.bs}}</dd>
                        <dd><span>紧急联系：{{showHide == 1 ? user.jj_name : user.jj_names}}</span>      电话：{{showHide == 1 ? user.jj_tel : user.jj_tels}} </dd>
                    </dl>
                    <dl>
                        <dt><img src="../../img/icon2.png" alt=""> 所属公司</dt>
                        <dd>公司名称：{{user.title}}</dd>
                        <dd>岗位：{{ user.gangwei }}</dd>
                        <dd>工作时间：{{user.gztime}}</dd>
                    </dl>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts'
import mapJson from '../../assets/shanxi.json'
export default {
    components: {

    },
    data () {
        return {
            showHide: 0,
            user: {
                avatar: '',
                imei: '--',
                name: '--',
                names: '--',
                tel: '--',
                tels: '--',
                bs: '--',
                jj_name: '--',
                jj_tel: '--',
                jj_names: '--',
                jj_tels: '--',
                title: '--',
                address: '-------',
                gangwei: '--',
                gztime: '--',
                type: '--',
                imeiState: ''
            },
        }
    },
    mounted () {
        this.fn()
        this.getUserShow()
        this.clickTimes();
    },
    methods: {
        clickTimes(){
            this.timer = setInterval(() => {
                this.getUserShow();
            }, 10000)
        },
        getUserShow(){
            var that = this
            // console.log(that.keyword,"关键词关键词关键词关键词关键词")
            that.axios.get(that.$url.baseUrl+'index/usershow?value='+that.keyword, {
                })
                .then(function (res) {
                    if(res.data.code == 1){
                        that.user = res.data.data

                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        fn() {
            let _this = this

            _this.axios.post(this.$url.baseUrl + 'index/getCityUser', {
                })
                .then(function (res) {
                    console.log(res.data, '城市人员')

                    let myChart = echarts.init(document.getElementById('map'))
                    console.log(mapJson)
                    echarts.registerMap('临汾市', mapJson, {}) //
                    var mapJsonlen = mapJson.features.length,
                        data = mapJson.features
                    var color = [
                        '#12245A'
                    ]
                    var mapData = mapJson.features.map((item, index) => {
                        return {
                            name: item.properties.name,
                            value: 1000,
                            level: item.properties.level,
                            cityCode: item.properties.adcode,
                            itemStyle: {
                                normal: {
                                    show: true,
                                    areaColor: color[index] || '#12245A'
                                }
                            }
                        }
                    })

                    // eslint-disable-next-line no-redeclare
                    var mapData = [
                        {name: '大同市', value: 20057.34},
                        {name: '朔州市', value: 15477.48},
                        {name: '忻州市', value: 31686.1},
                        {name: '吕梁市', value: 6992.6},
                        {name: '太原市', value: 44045.49, selected: true},
                        {name: '阳泉市', value: 40689.64},
                        {name: '晋中市', value: 37659.78},
                        {name: '长治市', value: 45180.97},
                        {name: '临汾市', value: 45180.97},
                        {name: '晋城市', value: 45180.97},
                        {name: '运城市', value: 45180.97}
                    ]

                    // eslint-disable-next-line no-redeclare
                    var mapData = res.data

                    let option = {

                        tooltip: {
                            trigger: 'item',
                            backgroundColor: 'rgba(0,0,0,0)',
                            borderColor: 'rgba(0,0,0,0)',
                            extraCssText: 'box-shadow: 0 0 0 rgba(0, 0, 0, 0);',
                            zIndex: 400,
                            textStyle: { // 提示框浮层的文本样式。
                                color: '#41feff',
                                fontStyle: 'normal',
                                fontWeight: 'normal',
                                fontFamily: 'sans-serif',
                                fontSize: 14
                            },
                            padding: 0, // 提示框浮层内边距，
                            formatter: function (params) {
                                let showname = params
                                return (
                                    `
        <div class="section">
            <p class="city">客户城市：${showname.data.name}</p>
            <p class="user">使用人数:${showname.data.value}</p>
      </div>
      `
                                )
                            }
                        },

                        series: [
                            {
                                name: '山西省',
                                type: 'map',
                                symbol: 'image://./static/guizi/images/044br.gif',
                                mapType: '临汾市',
                                roam: true, // 是否开启鼠标缩放和平移漫游
                                geoIndex: 0, // 不可缺少，否则无tooltip 指示效果
                                aspectScale: .85, // 地图长度比
                                // 鼠标经过高亮显示
                                selectedMode: 'single',
                                emphasis: {
                                    itemStyle: {
                                        opacity: 1,
                                        borderColor: '#54E7EE',
                                        borderWidth: '3',
                                        areaColor: '#54E7EE'
                                    }
                                },
                                label: {
                                    normal: {
                                        show: true, // 是否显示地区名称
                                        color: '#ffffff', // 字体的显示颜色
                                        fontSize: 12 // 字体大小
                                    },
                                    emphasis: {
                                        show: true,
                                        color: '#ffffff' // 鼠标移动上去的字体颜色
                                    }
                                },
                                // eslint-disable-next-line no-dupe-keys
                                roam: false,
                                itemStyle: {
                                    normal: {
                                        borderWidth: 2, // 边际线大小
                                        borderColor: '#6CF3FA', // 边界线颜色
                                        areaColor: '#09295b'// 默认区域颜色
                                    },
                                    emphasis: {
                                        show: true,
                                        areaColor: '#54E7EE', // 鼠标滑过区域颜色
                                        label: {
                                            show: true,
                                            textStyle: {
                                                color: '#1D4088',
                                                fontWeight: 'bold'
                                            }
                                        }
                                    }

                                },
                                // eslint-disable-next-line no-dupe-keys
                                label: {
                                    normal: {
                                        show: true,
                                        textStyle: {
                                            color: '#FFFFFF'
                                        }
                                    }
                                },

                                data: mapData
                                // data:
                            }
                        ]
                    }

                    myChart.setOption(option)
                    _this.$refs.chartb.mapStateHand();
                    myChart.on('click', function (params) {
                        // console.log(params.data)
                    })

                    myChart.on('click', function (res) {
                        // console.log(res)
                        if (res.componentSubType === 'map') {
                            console.log()
                            console.log('关键词')
                            // alert(`点击了 ${res.name} 地图`);
                            // eslint-disable-next-line eqeqeq
                            if (sessionStorage.getItem('keywords') != null || sessionStorage.getItem('keywords') != undefined) {
                                _this.$router.push('/index/city?map=' + res.name + '&keyword=' + sessionStorage.getItem('keywords'))
                            } else {
                                _this.$router.push('/index/city?map=' + res.name)
                            }
                        }
                    })

                    // 动态显示tooptip，每隔3秒去提示

                    var faultByHourIndex = 0 // 播放所在下标

                    var faultByHourTime = setInterval(function () {
                        // 使得tootip每隔三秒自动显示

                        myChart.dispatchAction({

                            type: 'showTip', // 根据 tooltip 的配置项显示提示框。

                            seriesIndex: 0,

                            dataIndex: faultByHourIndex

                        })

                        faultByHourIndex++

                        // faultRateOption.series[0].data.length 是已报名纵坐标数据的长度

                        if (faultByHourIndex > mapData.length) {
                            faultByHourIndex = 0
                        }
                    }, 3000)

                    // 窗口改变 重新调用绘制地图
                    window.addEventListener('resize', () => {
                        if (myChart && myChart.resize) {
                            myChart.resize()
                        }
                    })
                })
                .catch(function (error) {
                    console.log(error)
                })
        }
    }
}
</script>

<style scoped>
.user_section dl dd{
    margin: 0;
}
#section{
    position: absolute;
    top: 68vh;
    left: 0;
    right: 0;
}
.avatarName{
    position: relative;
}
#headimgurl{
    position: absolute;
    right: 10px;
    top: 0;
    width: 80px;
}
.boxRadius{
    font-size: 15px;
}
#app, body, html{
    height: 100%;
}
#user_card{
    position: absolute;
    right: 0;
    top: 100px;
}
#user_card span{
    position: absolute;
    z-index: 9;
    width: 100%;
    left: 0;
    font-size: 12px;
    color: #FFFFFF;
    padding-left: 27px;
    line-height: 18px;
}
.user_section,.equipment{
    padding: 0 10px;
}
.equipment{
    margin: 0;
    font-size: 15px;
}
.user_section dl dt{
    font-size: 15px;
}
.overFixed{
    height: 100%;
    background: none;
    background: #161A47;
}
#page{
    /*background: #161A47;*/
}
</style>



// WEBPACK FOOTER //
// src/pages/index/maps.vue